import { render, staticRenderFns } from "./Seperator.vue?vue&type=template&id=51f958d2&scoped=true&"
import script from "./Seperator.vue?vue&type=script&lang=js&"
export * from "./Seperator.vue?vue&type=script&lang=js&"
import style0 from "./Seperator.vue?vue&type=style&index=0&id=51f958d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51f958d2",
  null
  
)

export default component.exports